"use client";

import React, { useState, useEffect } from 'react';

export default function PopupSocio() {
  const [isOpen, setIsOpen] = useState(false);
  const [popupData, setPopupData] = useState<any>(null);

  useEffect(() => {
    // Busca o popup dinâmico do endpoint de notícias (tipo = Popup Site)
    const fetchPopup = async () => {
      try {
        const res = await fetch('https://api.arfainfo.com.br/api/noticias/todas', { cache: 'no-store' });
        const data = await res.json();
        if (data.sucesso && data.dados) {
          const popups = data.dados.filter((n: any) => n.tipo === 'Popup Site');
          if (popups.length > 0) {
            // Pega o mais recente
            const activePopup = popups[0];
            setPopupData(activePopup);

            // Verifica se este popup específico já foi visto usando o ID dele
            const hasSeenPopup = sessionStorage.getItem(`hasSeenPopupST_${activePopup.id}`);
            if (!hasSeenPopup) {
              const timer = setTimeout(() => {
                setIsOpen(true);
              }, 800);
              return () => clearTimeout(timer);
            }
          }
        }
      } catch (e) {
        console.error('Erro ao buscar popups', e);
      }
    };
    
    fetchPopup();
  }, []);

  const handleClose = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setIsOpen(false);
    if (popupData) {
      sessionStorage.setItem(`hasSeenPopupST_${popupData.id}`, 'true');
    }
  };

  if (!isOpen || !popupData) return null;

  return (
    <div 
      className="fixed inset-0 z-[99999] flex items-center justify-center p-6 bg-black/80 backdrop-blur-sm"
      onClick={handleClose}
    >
      <div 
        className="relative inline-flex h-auto max-h-[85vh] max-w-[90vw] sm:max-w-[500px] animate-[pop_0.3s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          onClick={handleClose}
          className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center bg-[#8A1538] text-white rounded-full hover:bg-red-700 transition-colors z-10 border-2 border-white shadow-xl cursor-pointer"
          title="Fechar"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {popupData.resumo ? (
          <a 
            href={popupData.resumo} 
            target="_blank" 
            rel="noopener noreferrer"
            className="block h-full w-full cursor-pointer rounded-2xl relative group"
            onClick={() => {
              sessionStorage.setItem(`hasSeenPopupST_${popupData.id}`, 'true');
              setIsOpen(false);
            }}
          >
            <img 
              src={popupData.banner_url || "https://cdn.nense.com.br/prod/assets/images/popup2.png"} 
              alt={popupData.titulo} 
              className="w-auto h-full max-h-[85vh] object-contain rounded-2xl drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-300"
            />
          </a>
        ) : (
          <div 
            className="block h-full w-full rounded-2xl relative cursor-pointer"
            onClick={handleClose}
          >
             <img 
              src={popupData.banner_url || "https://cdn.nense.com.br/prod/assets/images/popup2.png"} 
              alt={popupData.titulo} 
              className="w-auto h-full max-h-[85vh] object-contain rounded-2xl drop-shadow-2xl"
            />
          </div>
        )}

      </div>
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes pop {
          0% { transform: scale(0.9); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}} />
    </div>
  );
}
